export enum ChoixQteCalculPrixBonCfDetailEnum {
  BESOIN_UT,
  QTE_COMMANDEE_REAJUSTEE
}
